import React from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  IOpenDataReadinessDimension,
  OpenDataReadinessStatus,
} from "../../interfaces";

export const STATUS_META: Record<
  OpenDataReadinessStatus,
  { bg: string; label: string }
> = {
  green: { bg: "success", label: "Ready" },
  amber: { bg: "warning", label: "Partial" },
  red: { bg: "danger", label: "Blocked" },
  error: { bg: "secondary", label: "Errored" },
};

/** A dimension's light, with its reason on hover so the grade is never a mystery. */
export const StatusPill: React.FC<{
  dimension: IOpenDataReadinessDimension;
  label: string;
}> = ({ dimension, label }) => {
  const meta = STATUS_META[dimension.status];
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{dimension.reason || meta.label}</Tooltip>}
    >
      <Badge bg={meta.bg} className="me-1">
        {label}
      </Badge>
    </OverlayTrigger>
  );
};

export const OverallPill: React.FC<{ status: OpenDataReadinessStatus }> = ({
  status,
}) => {
  const meta = STATUS_META[status];
  return <Badge bg={meta.bg}>{meta.label}</Badge>;
};

export const formatDuration = (ms: number): string => {
  if (!ms) return "—";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  return `${m}m ${s % 60}s`;
};
